import React from "react";

// Heros
import ToolHeroImg from "../images/hero/hero_final_app.svg";


export const UserRoleContext = React.createContext(undefined);


const DataApps = [
  {
    category: "Data Apps",
    apps: [
      {
        name: "Megabank",
        icon: "",
        href: "#/app/megabank",
        link: "https://megabank.data.labillion.cn",
        doc: "https://docs.data.labillion.cn/megabank",
        state: true,
        mainColor: "#078aac",
        desc: "Your modern workspace for discovery holo data.",
        heroImg: ToolHeroImg,
      },
    ],
  },
];



export { DataApps };
